import { AllVisitorsList, PastVisitorsList, UpcomingVisitorsList } from 'components/visitors-list';
import { Route, Routes } from 'react-router-dom';

import { DefaultRedirect } from 'pages/visits-page/default-redirect';
import { DefaultRedirect as CreateOnlyDefaultRedirect } from 'pages/create-only-page/default-redirect';
import { NewVisitorPage } from 'pages/new-visit-page';
import { VisitDetailsPage } from 'pages/visit-details-page';
import { PendingVisitPage } from 'pages/pending-visit-page';
import { EditVisitPage } from 'pages/edit-visit-page';
import { useFieldMetadata } from 'store/ui-metadata/hooks';

/**
 * Consolidated routes component for visits
 * Combines routes from both VisitsPage and CreateOnlyPage
 * Default redirect behavior depends on view_visits_enabled feature flag
 */
export const VisitsRoutes = (): JSX.Element => {
  const viewVisitsEnabled = useFieldMetadata('view_visits_enabled');
  const DefaultRedirectComponent = viewVisitsEnabled ? DefaultRedirect : CreateOnlyDefaultRedirect;

  return (
    <Routes>
      {/* Most specific routes first - nested path before dynamic */}
      {/* Routes only available when view_visits_enabled */}
      {viewVisitsEnabled ? (
        <>
          <Route path="upcoming/PENDING" element={<PendingVisitPage />} />
          <Route path="all" element={<AllVisitorsList />} />
          <Route path="upcoming" element={<UpcomingVisitorsList />} />
          <Route path="past" element={<PastVisitorsList />} />
        </>
      ) : null}
      {/* New visit form - available in both modes */}
      <Route path="new/*" element={<NewVisitorPage />} />
      {/* Dynamic routes - edit route must come before details route */}
      {/* Use /* to allow nested routes like /edit/visitor, /edit/date */}
      <Route path=":visitUiType/:visitId/edit/*" element={<EditVisitPage />} />
      <Route path=":visitUiType/:visitId" element={<VisitDetailsPage />} />
      {/* Catch-all - redirect behavior depends on view_visits_enabled */}
      <Route path="*" element={<DefaultRedirectComponent />} />
    </Routes>
  );
};
